var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "page",
      attrs: { id: "About", "data-page": "teaching-toolkit" }
    },
    [
      _c("appModal", {
        ref: "appModalRef",
        attrs: { countries: _vm.DBCountries }
      }),
      _c("appHeader", {
        attrs: { bgColor: "blue", page: "about" },
        on: { headerMenuClicked: _vm.menuClicked }
      }),
      _c("div", { staticClass: "main" }, [
        _c("div", { staticClass: "main_inner" }, [
          _vm._m(0),
          _c("section", { staticClass: "main_section section_about" }, [
            _c("div", { staticClass: "section_content" }, [
              _vm._m(1),
              _c(
                "div",
                { staticClass: "toolkit_sections" },
                _vm._l(_vm.toolkitItems, function(item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "toolkit_section" },
                    [
                      _c("div", { staticClass: "toolkit_section_icon" }, [
                        _c("img", {
                          attrs: { src: item.icon, alt: item.title }
                        })
                      ]),
                      _c("div", { staticClass: "toolkit_section_content" }, [
                        _c("h3", { staticClass: "toolkit_section_title" }, [
                          _vm._v(_vm._s(item.title))
                        ]),
                        _c("p", { staticClass: "toolkit_section_text" }, [
                          _vm._v(_vm._s(item.text))
                        ])
                      ])
                    ]
                  )
                }),
                0
              ),
              _vm._m(2)
            ])
          ])
        ])
      ]),
      _c("appFooter"),
      _c("cookiesConsent")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "main_section" }, [
      _c("div", { staticClass: "section_content" }, [
        _c("h1", { staticClass: "title_page text_title2" }, [
          _vm._v(
            "\n                        Teaching Toolkit\n                    "
          )
        ]),
        _c("p", { staticClass: "text_p" }, [
          _vm._v(
            "The teaching toolkit of the Atlas of the Offshore World offers multiple tools to facilitate the engagement of young people in discussions related to illicit financial flows, tax evasion and avoidance. The toolkit consists of explainer videos, research tasks, readings, tutorials, quizes, and workshop instructions. The tools are modular: the teacher can select the tools that fit the educational programme and combine them with other activities. This toolkit was developed by Skatteforsk - Norwegian Centre for Tax Research supported by funding from the Norwegian Finance Market Fund."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "toolkit_hero" }, [
      _c("img", {
        staticClass: "toolkit_hero_image",
        attrs: {
          src: "/images/toolkit/teaching-toolkit-logo.png",
          alt: "Teaching Toolkit"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "toolkit_cta" }, [
      _c("h2", { staticClass: "toolkit_cta_title" }, [
        _vm._v("Do you want to use the teaching toolkit?")
      ]),
      _c("p", { staticClass: "toolkit_cta_text" }, [
        _vm._v("Get in touch with us at "),
        _c(
          "a",
          { attrs: { href: "mailto:contact@atlas-offshore-world.org" } },
          [_vm._v("contact@atlas-offshore-world.org")]
        ),
        _vm._v(" with any questions or ideas to further develop the toolkit.")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e9fbb0c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e9fbb0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/teaching-toolkit/index.vue
// module id = 5hwF
// module chunks = 3